export const BUSINESS = {
  name: "Last Cut Landscaping",
  tagline: "Quality Care. Lasting Impressions.",
  phone: "07459 520 665",
  phoneDial: "+447459520665",
  whatsapp: "447459520665",
  email: "lastcutlandscaping@gmail.com",
  hq: "Falkirk, Central Belt, Scotland",
  hours: "Mon–Sat · 8:00 – 18:00",
  facebook: "https://facebook.com/lastcutlandscaping",
  instagram: "https://instagram.com/lastcutlandscaping",
  logo: "https://customer-assets.emergentagent.com/job_premium-landscaping-1/artifacts/7ykqp7kz_Screenshot_20260511_183605_Gallery.jpg",
};

// Site URL used for canonical / OG / schema. Driven by env so deployments to any domain work.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://lastcutlandscaping.co.uk").replace(/\/$/, "");
export const canonical = (path = "/") => `${SITE_URL}${path.startsWith("/") ? path : "/" + path}`;
